import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PautasLayer from "../components/PautasLayer";
import { useTranslation } from "../i18n/I18nContext";

const PautasPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("pauta.breadcrumb")} />
      <PautasLayer />
    </MasterLayout>
  );
};

export default PautasPage;
